export enum RateType {
  FIXED = 'FIXED',
  VARIABLE = 'VARIABLE'
}

export enum FixedRateCategory {
  PER_SQM = 'PER_SQM',
  PER_PERIOD = 'PER_PERIOD'
}

export enum VariableRateCategory {
  PERCENTAGE = 'PERCENTAGE'
}

export enum TimePeriod {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  WEEKEND = 'WEEKEND'
}

export interface SpaceDefaultRate {
  id?: number;
  spaceId: number;
  rateType: RateType;
  category: FixedRateCategory | VariableRateCategory;
  timePeriod: TimePeriod;
  value: number;
  isDefault: boolean; // Add this property to store default selection
  createdDate?: Date;
  updatedDate?: Date;
}

export interface SpaceDefaultPricingInterface {
  spaceId: number;
  spaceName: string;
  rates: SpaceDefaultRate[];
} 